import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/browser';

import { Analytics, user, redirectToApplication } from '../index';
import AtomLoadingPopup from '../AtomLoadingPopup/AtomLoadingPopup';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import { setLocale, W } from '../i18n/i18n';

function Authenticated({ children }: { children: React.ReactNode }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticating, setAuthenticating] = useState(true);
  const [errorCode, setErrorCode] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState(undefined);

  useEffect(() => {
    Analytics.post('/api/user/whoami')
      .then(response => {
        if (response.code !== 0) {
          throw response;
        }

        user.set(response.result);
        if (!user.preference) {
          throw new Error('No user preference found');
        }
        setLocale(user.preference.language);

        const { enableSentry } = window.__config__;
        if (enableSentry) {
          const username =
            response.result.basicInfo?.firstName &&
            response.result.basicInfo?.lastName
              ? `${response.result.basicInfo.firstName} ${response.result.basicInfo.lastName}`
              : '';
          Sentry.configureScope(scope => {
            scope.setUser({
              id: response.result.userId,
              email: response.result.basicInfo?.email,
              username,
            });
          });
        }

        setAuthenticated(true);
        setAuthenticating(false);
      })
      .catch(error => {
        setAuthenticated(false);
        setErrorCode(error.status);
        setErrorMessage(error.statusText);

        if (error.status === 401) {
          redirectToApplication('USER', '', {
            ref: encodeURIComponent(String(window.location)),
          });
        } else {
          throw error;
        }
      });
  }, []);

  if (authenticated) {
    return <div>{children}</div>;
  }

  if (authenticating) {
    return <AtomLoadingPopup visible />;
  }

  if (errorCode === 401) {
    return (
      <AtomLoadingPopup visible text={W('shared.authenticated.redirect')} />
    );
  }

  return <ErrorPage errorCode={errorCode} message={errorMessage} />;
}

export default Authenticated;
